import React from "react";
import { Modal, Button } from "react-bootstrap";

const MemberConnectionModal = ({ show, onHide, onShowConnection }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="post-video-modal"
    >
      <Modal.Header closeButton onHide={onHide}></Modal.Header>
      <Modal.Body>
        <div className="text-center p-4">
          <h4 className="mb-3">See It In Action</h4>
          <p className="mb-4">
            Next, watch how a job seeker and an employed member connect through
            JobInfoNetwork.
          </p>
          <Button
            variant="success"
            size="lg"
            onClick={onShowConnection}
            className="px-4"
          >
            See a Member to Member Connection
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MemberConnectionModal;
